export interface IActiveStaffsFilter {
    Keyword?: string;
    Archive: boolean;
    Limit?: number;
    Offset?: number;
    SortColumn?: string;
    SortOrder?: SortOrderEnum;
}

export type SortOrderEnum = 0 | 1;
export const SortOrderEnum = {
    Ascending: 0 as SortOrderEnum,
    Descending: 1 as SortOrderEnum
};

export interface IPasswordCheck {
    Password: string;
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/IActiveStaffsFilter.ts